import { UNKNOWN_DATA_SOURCE_TYPE } from 'src/constants/dataSourceTypeDescription';
import { isVirtualGraph } from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to include dataSourceType information in VirtualGraph Resource nodes
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v20 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v20Projects(prevState.projects);
  }

  return nextState;
};

const v20Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          nodeDataArray: project.diagram.model.nodeDataArray.map((node) => {
            if (isVirtualGraph(node) && project.virtualGraphsById[node.value]) {
              return {
                ...node,
                dataSourceType:
                  project.virtualGraphsById[node.value].dataSourceType ||
                  UNKNOWN_DATA_SOURCE_TYPE,
              };
            }
            return node;
          }),
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
